export function displayName(first?: string | null, last?: string | null, email?: string | null, fallback = 'Unknown') {
  return [first, last].map(part => part?.trim()).filter(Boolean).join(' ') || email?.trim() || fallback
}

export function initialsFor(value: string) {
  const text = value.trim()
  if (!text) return '--'
  const emailPrefix = text.includes('@') ? text.split('@')[0] : text
  const parts = emailPrefix.split(/[\s._-]+/).filter(Boolean)
  return (parts.length > 1 ? parts.map(part => part[0]).join('') : emailPrefix.slice(0, 2)).slice(0, 2).toUpperCase()
}
